import { defineNuxtPlugin } from '#app/nuxt'
import { LazyElementApplinks, LazyElementButton, LazyElementCommonPaymentComponentsFormError, LazyElementCommonPaymentComponentsHr, LazyElementCommonPaymentComponentsNoPaymentMethodInfo, LazyElementCommonPaymentComponentsPaymentErrors, LazyElementCommonPaymentComponentsPaymentFormInputs, LazyElementCommonPaymentComponentsPaymentFormStripe, LazyElementCommonPaymentComponentsPaymentMethodIcons, LazyElementCommonPaymentComponentsPriceInfo, LazyElementCommonPaymentComponentsProviderButton, LazyElementCommonPaymentComponentsProviderTabs, LazyElementCommonPaymentComponentsZipCodeInput, LazyElementCommonRegistrationComponentsOtpActions, LazyElementCommonRegistrationComponentsRegisterInput, LazyElementConditionalButton, LazyElementConditionalText, LazyElementCountdown, LazyElementDateentryComponentsDateSelect, LazyElementDateentry, LazyElementEndingprogressComponentsProgressSteps, LazyElementEndingprogress, LazyElementFaqComponentsAccordion, LazyElementFaq, LazyElementFileElementError, LazyElementFile, LazyElementHeightinput, LazyElementImageComponentsEmbed, LazyElementImageComponentsImage, LazyElementImageComponentsVideo, LazyElementImage, LazyElementImageselection, LazyElement, LazyElementLocationpicker, LazyElementMoneyback, LazyElementNumericinput, LazyElementPaymentResultComponentsPaymentDetails, LazyElementPaymentResultComponentsPincodeCard, LazyElementPaymentResult, LazyElementPaymentWithTabs, LazyElementPayment, LazyElementPlain, LazyElementPlanSelectionComponentsPlanItem, LazyElementPlanSelection, LazyElementRegistration, LazyElementSelection, LazyElementSinglerowtext, LazyElementSurveyprogress, LazyElementTestimonialsComponentsBlock, LazyElementTestimonialsComponentsStar, LazyElementTestimonials, LazyElementText, LazyElementTimeentryComponentsTimeSelect, LazyElementTimeentry, LazyElementTranslation, LazyElementVideo, LazyElementWeightinput, LazyElementWrapper, LazySectionColumn, LazySection, LazySectionZotloFooter } from '#components'
const lazyGlobalComponents = [
  ["ElementApplinks", LazyElementApplinks],
["ElementButton", LazyElementButton],
["ElementCommonPaymentComponentsFormError", LazyElementCommonPaymentComponentsFormError],
["ElementCommonPaymentComponentsHr", LazyElementCommonPaymentComponentsHr],
["ElementCommonPaymentComponentsNoPaymentMethodInfo", LazyElementCommonPaymentComponentsNoPaymentMethodInfo],
["ElementCommonPaymentComponentsPaymentErrors", LazyElementCommonPaymentComponentsPaymentErrors],
["ElementCommonPaymentComponentsPaymentFormInputs", LazyElementCommonPaymentComponentsPaymentFormInputs],
["ElementCommonPaymentComponentsPaymentFormStripe", LazyElementCommonPaymentComponentsPaymentFormStripe],
["ElementCommonPaymentComponentsPaymentMethodIcons", LazyElementCommonPaymentComponentsPaymentMethodIcons],
["ElementCommonPaymentComponentsPriceInfo", LazyElementCommonPaymentComponentsPriceInfo],
["ElementCommonPaymentComponentsProviderButton", LazyElementCommonPaymentComponentsProviderButton],
["ElementCommonPaymentComponentsProviderTabs", LazyElementCommonPaymentComponentsProviderTabs],
["ElementCommonPaymentComponentsZipCodeInput", LazyElementCommonPaymentComponentsZipCodeInput],
["ElementCommonRegistrationComponentsOtpActions", LazyElementCommonRegistrationComponentsOtpActions],
["ElementCommonRegistrationComponentsRegisterInput", LazyElementCommonRegistrationComponentsRegisterInput],
["ElementConditionalButton", LazyElementConditionalButton],
["ElementConditionalText", LazyElementConditionalText],
["ElementCountdown", LazyElementCountdown],
["ElementDateentryComponentsDateSelect", LazyElementDateentryComponentsDateSelect],
["ElementDateentry", LazyElementDateentry],
["ElementEndingprogressComponentsProgressSteps", LazyElementEndingprogressComponentsProgressSteps],
["ElementEndingprogress", LazyElementEndingprogress],
["ElementFaqComponentsAccordion", LazyElementFaqComponentsAccordion],
["ElementFaq", LazyElementFaq],
["ElementFileElementError", LazyElementFileElementError],
["ElementFile", LazyElementFile],
["ElementHeightinput", LazyElementHeightinput],
["ElementImageComponentsEmbed", LazyElementImageComponentsEmbed],
["ElementImageComponentsImage", LazyElementImageComponentsImage],
["ElementImageComponentsVideo", LazyElementImageComponentsVideo],
["ElementImage", LazyElementImage],
["ElementImageselection", LazyElementImageselection],
["Element", LazyElement],
["ElementLocationpicker", LazyElementLocationpicker],
["ElementMoneyback", LazyElementMoneyback],
["ElementNumericinput", LazyElementNumericinput],
["ElementPaymentResultComponentsPaymentDetails", LazyElementPaymentResultComponentsPaymentDetails],
["ElementPaymentResultComponentsPincodeCard", LazyElementPaymentResultComponentsPincodeCard],
["ElementPaymentResult", LazyElementPaymentResult],
["ElementPaymentWithTabs", LazyElementPaymentWithTabs],
["ElementPayment", LazyElementPayment],
["ElementPlain", LazyElementPlain],
["ElementPlanSelectionComponentsPlanItem", LazyElementPlanSelectionComponentsPlanItem],
["ElementPlanSelection", LazyElementPlanSelection],
["ElementRegistration", LazyElementRegistration],
["ElementSelection", LazyElementSelection],
["ElementSinglerowtext", LazyElementSinglerowtext],
["ElementSurveyprogress", LazyElementSurveyprogress],
["ElementTestimonialsComponentsBlock", LazyElementTestimonialsComponentsBlock],
["ElementTestimonialsComponentsStar", LazyElementTestimonialsComponentsStar],
["ElementTestimonials", LazyElementTestimonials],
["ElementText", LazyElementText],
["ElementTimeentryComponentsTimeSelect", LazyElementTimeentryComponentsTimeSelect],
["ElementTimeentry", LazyElementTimeentry],
["ElementTranslation", LazyElementTranslation],
["ElementVideo", LazyElementVideo],
["ElementWeightinput", LazyElementWeightinput],
["ElementWrapper", LazyElementWrapper],
["SectionColumn", LazySectionColumn],
["Section", LazySection],
["SectionZotloFooter", LazySectionZotloFooter],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
